<template xmlns:v-popover="">
    <div class="home-head">
        <img class="bg_img" src="../assets/bg_blue.png" mode="aspectFit "/>
        <div class="desc_area">
            <div class="left_area">
                <span class="title">帮助中心<span style="margin-left: 20px;color:#7490f7">HELP CENTER</span></span>
                <span class="title_desc">无需复杂编程，轻松实现自动化流程</span>
            </div>
            <!--<img class="img2" src="../assets/title.png" mode="widthFix ">-->
            <div class="right_area">
                <img class="img3" src="../assets/zhuanjia.png" mode="widthFix ">
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "TopBarSecond",
        data() {
            return {}
        },
        computed: {},
        methods: {},
        mounted() {
        }
    };
</script>

<style lang="less" scoped>
    .home-head {
        background-color: #252a2f;
        height: 160px;
        width: 100%;
        /*left: 0;*/
        /*top: 50px;*/
        position: relative;
        /*z-index: 1000 !important;*/
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 50px;
        .bg_img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100vw;
            height: 160px;
        }
        /*background-color: red;*/
        .desc_area{
            position: absolute;
            top:0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
        }
        .left_area{
            margin-left: 440px;
            min-width: 500px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }
        .right_area {
            width: 300px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }
        .title {
            font-size: 36px;
            font-weight: 800;
            font-family: 微软雅黑;
            font-style: oblique;
            color: white;
            letter-spacing: 2px;
        }
        .title_desc {
            line-height: 40px;
            color: white;
            font-size: 14px;
            font-family: 微软雅黑;
        }
        .img2 {
            width: 600px;
        }
        .img3 {
            width: 280px;
        }
    }
</style>
